// AvatarSelectModal Component
// Allows users to change their avatar from the profile page

import React, { useState } from 'react';
import AvatarPicker from '../AvatarPicker/AvatarPicker';
import Avatar from '../Avatar/Avatar';
import './AvatarSelectModal.css';

const AvatarSelectModal = ({ isOpen, currentAvatar, onSelect, onClose, isSaving = false }) => {
  const [selectedAvatar, setSelectedAvatar] = useState(currentAvatar);

  // Reset selection when modal opens
  React.useEffect(() => {
    if (isOpen) {
      setSelectedAvatar(currentAvatar);
    }
  }, [isOpen, currentAvatar]);

  const handleSave = () => {
    if (selectedAvatar !== currentAvatar) {
      onSelect(selectedAvatar);
    } else {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="avatar-modal-overlay" onClick={onClose} onKeyDown={handleKeyDown}>
      <div className="avatar-modal" onClick={(e) => e.stopPropagation()}>
        <div className="avatar-modal-header">
          <div className="current-avatar-preview"><Avatar value={selectedAvatar} alt="" /></div>
          <h2>Change Your Avatar</h2>
          <p>Pick a new icon for your profile</p>
        </div>

        <AvatarPicker value={selectedAvatar} onChange={setSelectedAvatar} disabled={isSaving} />

        <div className="avatar-modal-actions">
          <button
            className={`avatar-save-btn ${isSaving ? 'saving' : ''}`}
            onClick={handleSave}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <span className="avatar-spinner"></span>
                Saving...
              </>
            ) : (
              'Save Avatar'
            )}
          </button>
          <button
            className="avatar-cancel-btn"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AvatarSelectModal;
